import { type DashboardAudienceKind, type MaterialSymbolType } from '@front/model'

type AudienceOptionCopy = {
  icon: MaterialSymbolType
  title: string
  description: string
}

const ICONS: Map<DashboardAudienceKind, MaterialSymbolType> = new Map([
  ['yourself', 'person'],
  ['team', 'groups'],
  ['company', 'domain'],
  ['role', 'badge'],
  ['person', 'person_search'],
])

const TITLES: Map<DashboardAudienceKind, string> = new Map([
  ['yourself', 'Yourself'],
  ['team', 'A team'],
  ['company', 'Whole company'],
  ['role', 'A role'],
  ['person', 'A specific person'],
])

/**
 * What picking this audience means for who sees the dashboard. Wording matches
 * iOS so the rule reads identically on both platforms, except that the role
 * example is left generic — iOS names a specific role ("like all Setters") that
 * many companies don't use.
 */
export function getAudienceOptionCopy(
  kind: DashboardAudienceKind,
  companyName: string | undefined
): AudienceOptionCopy {
  return {
    icon: ICONS.get(kind) ?? 'person',
    title: TITLES.get(kind) ?? '',
    description: getDescription(kind, companyName),
  }
}

function getDescription(kind: DashboardAudienceKind, companyName: string | undefined): string {
  switch (kind) {
    case 'yourself':
      return 'Only you see it, on your Home'
    case 'team':
      return 'Everyone on the team gets it on their Home'
    case 'company':
      return companyName ? `Everyone at ${companyName} gets it` : 'Everyone at your company gets it'
    case 'role':
      return 'Everyone with that role gets it'
    case 'person':
      return 'Build it for one person you manage'
  }
}
